<div class="emails-type-list">
  <ng-container *ngIf="!loadingSpinner">
    <div class="email-type" *ngFor="let catWithTitle of categoriesWithTitle let i = index">
      <div class="email-type-title">
        {{catWithTitle.title}} CATEGORIES

        <!--<i class="pi pi-plus-circle"></i>-->
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let category of catWithTitle.categories; let j = index"
                  (click)="editCategory(category, i, j)">{{category.name}}
          </button>
          <button mat-button class="email-changer-button add-new-button"
                  (click)="newCategory(catWithTitle.title, i)">
            <i class="pi pi-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="email-type">
      <div class="email-type-title">
        MULTIPLICATIONS
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let multiplication of multiplications; let i = index"
                  (click)="editMultiplication(multiplication, i)">{{multiplication.name}}
          </button>
          <button mat-button class="email-changer-button add-new-button"
                  (click)="newMultiplication()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="email-type">
      <div class="email-type-title">
        MODIFIERS
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let modifier of modifiers; let i = index"
                  (click)="editModifier(modifier, i)">{{modifier.name}}
          </button>
          <button mat-button class="email-changer-button add-new-button"
                  (click)="addNewModifier()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="email-type">
      <div class="email-type-title">
        FEES
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let fee of feeItems; let i = index"
                  (click)="editFee(fee, i)">{{fee.name}}
          </button>
          <button mat-button class="email-changer-button add-new-button"
                  (click)="addNewFee()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="loading-body" *ngIf="loadingSpinner">
    <lib-progress-spinner></lib-progress-spinner>
  </div>
</div>
